// extracted by mini-css-extract-plugin
module.exports = {"card":"editHardware_card__38Iw_","headingDiv":"editHardware_headingDiv__2r5h-","headingInvite":"editHardware_headingInvite__2XKfW","bottonDiv":"editHardware_bottonDiv__2By2b"};